"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var DEFAULT_MARGIN = 5;

var bottomLeft = function bottomLeft(opts) {
  var trigger = opts.trigger,
      content = opts.content,
      viewport = opts.viewport;

  if (trigger.leftBottomAnchor.x + content.width <= viewport.width && trigger.leftBottomAnchor.y + DEFAULT_MARGIN + content.height <= viewport.height) {
    return {
      top: trigger.leftBottomAnchor.y + DEFAULT_MARGIN,
      left: trigger.leftBottomAnchor.x
    };
  }

  return false;
};

var bottomRight = function bottomRight(opts) {
  var trigger = opts.trigger,
      content = opts.content,
      viewport = opts.viewport;

  if (trigger.rightBottomAnchor.x - content.width >= 0 && trigger.leftBottomAnchor.y + DEFAULT_MARGIN + content.height <= viewport.height) {
    return {
      top: trigger.leftBottomAnchor.y + DEFAULT_MARGIN,
      left: trigger.rightBottomAnchor.x - content.width
    };
  }

  return false;
};

var upLeft = function upLeft(opts) {
  var trigger = opts.trigger,
      content = opts.content,
      viewport = opts.viewport;

  if (trigger.leftUpAnchor.x + content.width <= viewport.width && trigger.leftUpAnchor.y - DEFAULT_MARGIN - content.height >= 0) {
    return {
      top: trigger.leftUpAnchor.y - DEFAULT_MARGIN - content.height,
      left: trigger.leftBottomAnchor.x
    };
  }

  return false;
};

var upRight = function upRight(opts) {
  var trigger = opts.trigger,
      content = opts.content;

  if (trigger.rightUpAnchor.x - content.width >= 0 && trigger.rightUpAnchor.y - DEFAULT_MARGIN - content.height >= 0) {
    return {
      top: trigger.leftUpAnchor.y - DEFAULT_MARGIN - content.height,
      left: trigger.rightUpAnchor.x - content.width
    };
  }

  return false;
};

var resolvers = [bottomLeft, bottomRight, upLeft, upRight];

var defaultPositionResolver = function defaultPositionResolver(opts) {
  var pos;
  resolvers.some(function (resolver) {
    var ret = resolver(opts);

    if (ret) {
      pos = ret;
      return true;
    }

    return false;
  });

  if (pos) {
    return pos;
  }

  return {
    top: 0,
    left: 0
  };
};

var _default = defaultPositionResolver;
exports["default"] = _default;